import React from "react";
import {SeriesCharacterInfo, SeriesTermInfo} from "../../models/interfaces/series.interface.ts";
import SeriesCharacterBasicDetails from "./SeriesCharecterBasicDetails.tsx";
import SeriesCharacterExpendedDetails from "./SeriesCharecterExpendedDetails.tsx";
import {CharacterGender} from "../../models/types/charecterGender.ts";
import SeriesTermBasicDetails from "./SeriesTermBasicDetails.tsx";
import SeriesTermExpendedDetails from "./SeriesTermExpendedDetails.tsx";

interface SeriesTermProps {
  term: SeriesTermInfo;
  isOpen: boolean;
  onCharacterClick: (characterName: string) => void;
  termIndex: number;
  editTerm: (termId: string, value: string, field: "term" | "sourceLanguage" | "tagType" | "complexityScore" | "meaning") => void;
  setTermSynonyms: (termId: string, synonyms: string[]) => void;
  setTermTranslationsKey: (termId: string, oldTargetLanguage: string, newTargetLanguage: string) => void
  setTermTranslations: (termId: string, targetLanguage: string, translation: string) => void;
  removeTermTranslations: (termId: string, targetLanguage: string)=> void
  deleteTerm: (termId: string) => void;
}

const SeriesTerm: React.FC<SeriesTermProps> = (
  {
    term,
    isOpen,
    onCharacterClick,
    termIndex,
    editTerm,
    setTermSynonyms,
    setTermTranslationsKey,
    setTermTranslations,
    removeTermTranslations,
    deleteTerm
  }: SeriesTermProps) => {


  return (
    <div
      className={`${isOpen && "border border-brandPurple-500 rounded-xl p-2"} ${termIndex !== 0 ? "mt-4" : ""}`}
      key={term.termId}>
      <SeriesTermBasicDetails
        term={term}
        isOpen={isOpen}
        onClick={onCharacterClick}
        onDelete={deleteTerm}
      />
      <SeriesTermExpendedDetails
        isOpen={isOpen}
        term={term}
        editTerm={editTerm}
        setTermSynonyms={setTermSynonyms}
        setTermTranslationsKey={setTermTranslationsKey}
        setTermTranslations={setTermTranslations}
        removeTermTranslations={removeTermTranslations}
      />
    </div>
  )
}

export default SeriesTerm;